import { createSelector } from 'reselect';
import * as SeoConstants from './constants';

const seoSelector = createSelector(
    state => state[SeoConstants.SEO_KEY],
    seo => seo
);

const createSeoSelector = selector => createSelector(seoSelector, selector);

export default seoSelector;

export const hasSeo =
    createSeoSelector(seo => seo.hasSeo);

export const getSeoTitle =
    createSeoSelector(seo => seo[SeoConstants.TITLE_KEY]);

export const getSeoDescription =
    createSeoSelector(seo => seo[SeoConstants.DESCRIPTION_KEY]);

export const getSeoHeader =
    createSeoSelector(seo => seo[SeoConstants.HEADER_KEY]);

export const getSeoBlurb =
    createSeoSelector(seo => seo[SeoConstants.BLURB_KEY]);

export const getSeoBreadcrumbLinks =
    createSeoSelector(seo => seo[SeoConstants.BREADCRUMB_LINKS_KEY]);

export const getSeoRelatedLinks =
    createSeoSelector(seo => seo[SeoConstants.RELATED_LINKS_KEY]);

export const getSeoAbResponse =
    createSeoSelector(seo => seo[SeoConstants.SEO_AB_RESPONSE_KEY]);

export const getSeoShouldIndexPage =
    createSeoSelector(seo => seo[SeoConstants.SHOULD_INDEX_PAGE]);
